// Controller that manages a single polling room availability interval.
// Encapsulates interval lifecycle (start/stop) to avoid duplicate timers.
export interface PollingController {
  start: () => void;
  stop: () => void;
}

export const createPollingController = (
  fetcher: () => Promise<void>,
  intervalMs = 20_000,
): PollingController => {
  let timer: ReturnType<typeof setInterval> | null = null;

  // Run the provided fetcher and log errors so the interval
  // keeps running even if an iteration fails.
  const runFetcher = () => {
    void fetcher().catch((error) => {
      console.error('Polling fetch failed', error);
    });
  };

  // Start the polling interval if not running
  const start = () => {
    if (timer) {
      return;
    }

    runFetcher();

    timer = setInterval(runFetcher, intervalMs);
  };

  // Stop the polling interval if running
  const stop = () => {
    if (!timer) {
      return;
    }

    clearInterval(timer);
    timer = null;
  };

  return { start, stop };
};
